import React, { useEffect } from 'react';
import {
  fetchSignUpModel
} from "../../../../actions/my-puratos/account.action";
import { connect } from "react-redux";
import { Header } from "./components/Header";
import { Content } from "./components/Content/Content";

const SignUp = ({fetchSignUpModel, signUpModel, mapping, newCustomer = true}) => {

  useEffect(() => {
    fetchSignUpModel({ mapping, newCustomer });
  }, [mapping]);

  return (
    <div className={"sign-up"}>
      <div className={"sign-up__wrapper"}>
        <Header signUpModel={signUpModel}/>
        <Content signUpModel={signUpModel}/>
      </div>
    </div>
  )
}

const mapStateToProps = (state) => ({
  mapping: state.myPuratos_dashboard.mapping,
  signUpModel: state.myPuratos_account.signUpModel,
});

const mapDispatchToProps = {
  fetchSignUpModel,
};

export default connect(mapStateToProps, mapDispatchToProps)(SignUp);

